import * as yup from 'yup';
const logLevelSchema = yup
    .object()
    .shape({
    log_level: yup.number().required()
})
    .defined();
export default logLevelSchema;
